
import { signalStore, withMethods, withProps, withState } from '@ngrx/signals';
import { AuthState } from './auth.state';
import { login } from './methods/login.method';
import { logout } from './methods/logout.method';
import { inject } from '@angular/core';
import { Router } from '@angular/router';

const initialState: AuthState = {
  loggedIn: false,
};

export const AuthStore = signalStore(
  { providedIn: 'root' },
  withState(initialState),
  withProps(() => ({
    services: {
      router: inject(Router)
    }})
  ),
  withMethods(({ services, ...store }) => {
    return {
      login: login(store, services.router),
      logout: logout(store, services.router),
    };
  }),
);
export type AuthStore = InstanceType<typeof AuthStore>;
